export const metricIdsMapper = {
  shopPromiseAssetDiscovery: 'shop_promise_pdp_js_asset_discovery_duration_ms',
  shopPromiseAssetQueued: 'shop_promise_pdp_js_asset_queued_duration_ms',
  shopPromiseAssetFetched: 'shop_promise_pdp_js_asset_fetched_duration_ms',
  resolveVariant: 'shop_promise_pdp_resolve_variant_duration_ms',
  deliveryEstimateGraphQL: 'shop_promise_pdp_graphql_request_duration_ms',
  fcpToRender: 'shop_promise_pdp_fcp_to_render_ms',
  realWorldTime: 'shop_promise_pdp_rum_ms',
  mountingPoint: 'shop_promise_pdp_mounting_point_duration_ms',
  moduleFullyLoaded: 'shop_promise_pdp_module_fully_loaded_duration_ms',
};

export async function metricsConfig() {
  const {MetricInstrumentType, ValueType} = await import(
    '@shopify/opentelemetry-sdk'
  );

  return {
    [metricIdsMapper.shopPromiseAssetDiscovery]: {
      type: MetricInstrumentType.Histogram,
      description:
        'Time the Shop Promise JS asset waited until discovered, in milliseconds',
      valueType: ValueType.INT,
      boundaries: [
        10, 20, 40, 70, 100, 150, 200, 300, 500, 800, 1000, 1500, 2000, 3000,
      ],
    },
    [metricIdsMapper.shopPromiseAssetQueued]: {
      type: MetricInstrumentType.Histogram,
      description:
        'Time the Shop Promise JS asset spent in a queue, in milliseconds',
      valueType: ValueType.INT,
      boundaries: [
        10, 20, 40, 70, 100, 150, 200, 300, 500, 800, 1000, 1500, 2000, 3000,
      ],
    },
    [metricIdsMapper.shopPromiseAssetFetched]: {
      type: MetricInstrumentType.Histogram,
      description:
        'Time the Shop Promise JS asset got fetched, inclusive network latency, in milliseconds',
      valueType: ValueType.INT,
      boundaries: [
        10, 20, 40, 70, 100, 150, 200, 300, 500, 800, 1000, 1500, 2000, 3000,
        5000, 8000,
      ],
    },
    [metricIdsMapper.fcpToRender]: {
      type: MetricInstrumentType.Histogram,
      description:
        'Time to render only the Shop Promise PDP module, starting from FCP, inclusive of the Delivery Promise GraphQL call, in milliseconds',
      valueType: ValueType.INT,
      boundaries: [
        100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 2000, 2500, 3000,
        3500, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 12000, 15000, 20000,
      ],
    },
    [metricIdsMapper.realWorldTime]: {
      type: MetricInstrumentType.Histogram,
      description:
        'Time to render the Shop Promise PDP module, inclusive of the rest of the page, starting from the page interactive, in milliseconds',
      valueType: ValueType.INT,
      boundaries: [
        100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 2000, 2500, 3000,
        3500, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 12000, 15000, 20000,
      ],
    },
    [metricIdsMapper.deliveryEstimateGraphQL]: {
      type: MetricInstrumentType.Histogram,
      description:
        'Time to get response from the deliveryEstimate GraphQL endpoint, in milliseconds',
      valueType: ValueType.INT,
      boundaries: [
        10, 20, 40, 70, 100, 150, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
        1500, 2000, 3000, 4000, 5000, 7000, 10000,
      ],
    },
    [metricIdsMapper.resolveVariant]: {
      type: MetricInstrumentType.Histogram,
      description: 'Time to resolve variant ID, in milliseconds',
      valueType: ValueType.INT,
      boundaries: [
        10, 20, 40, 70, 100, 150, 200, 300, 500, 800, 1000, 1500, 2000, 3000,
        4000, 5000, 7000, 10000,
      ],
    },
    [metricIdsMapper.mountingPoint]: {
      type: MetricInstrumentType.Histogram,
      description: 'Time mount point is available, in milliseconds',
      valueType: ValueType.INT,
      boundaries: [
        10, 20, 40, 70, 100, 150, 200, 300, 500, 800, 1000, 1500, 2000, 3000,
        4000, 5000, 7000, 10000,
      ],
    },
    [metricIdsMapper.moduleFullyLoaded]: {
      type: MetricInstrumentType.Histogram,
      description:
        'Time the Shop Promise PDP module is fully loaded (after skeletons), in milliseconds',
      valueType: ValueType.INT,
      boundaries: [
        10, 20, 40, 70, 100, 150, 200, 300, 500, 800, 1000, 1500, 2000, 3000,
        4000, 5000, 7000, 10000,
      ],
    },
  };
}
